module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-preview/widget-detail-preview.component.scss
// module id = ./src/app/widgets/widget-detail/widget-detail-preview/widget-detail-preview.component.scss
// module chunks = main